module.exports = __webpack_public_path__ + "img/vmware_280x120.47bc8272.svg";